<template>
  <a-modal
    :title="isDatetime ? modalTit[0] : modalTit[1]"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="486px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div class="">
      <a-form
        :form="form"
      >
        <template v-if="isDatetime">
          <a-form-item
            :label="timeFormat"
            class="set-time-row"
          >
            <a-radio-group v-decorator="['formatdatetime', { initialValue: itemData.fieldconfig.formatdatetime + '' || '1' }]">
              <a-radio value="1">
                {{ $t('message["676"]') }}
              </a-radio>
              <a-radio value="2">
                {{ $t('message["677"]') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item
            class="set-time-row"
            :label="negativeTit"
          >
            <a-radio-group v-decorator="['isallowminus', { initialValue: itemData.fieldconfig.isallowminus + '' || '0' }]">
              <a-radio value="1">
                {{ $t('message["1092"]') }}
              </a-radio>
              <a-radio value="0">
                {{ $t('message["308"]') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            class="set-time-row"
            :label="decimalTit"
          >
            <a-radio-group v-decorator="['isallowdecimals', { initialValue: itemData.fieldconfig.isallowdecimals + '' || '0' }]">
              <a-radio value="1">
                {{ $t('message["1092"]') }}
              </a-radio>
              <a-radio value="0">
                {{ $t('message["308"]') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: []
    }
  },
  computed: {
    ...mapState('config/collect', ['datas']),
    isDatetime () {
      return this.itemData.fieldtype === 'datetime'
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    modalTit () {
      return this.$t('message["1031"]').split('|')
    },
    timeFormat () {
      return this.$t('message["1074"]')
    },
    negativeTit () {
      return this.$t('message["1534"]')
    },
    decimalTit () {
      return this.$t('message["1536"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.isDatetime) {
            this.itemData.fieldconfig.formatdatetime = values.formatdatetime * 1
          } else {
            this.itemData.fieldconfig.isallowminus = values.isallowminus * 1
            this.itemData.fieldconfig.isallowdecimals = values.isallowdecimals * 1
          }
          this.isLimitDialogShow = false
        }
      })
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      if (this.isDatetime) {
        this.$set(this.itemData.fieldconfig, 'formatdatetime', this.cloneData.fieldconfig.formatdatetime)
      } else {
        this.$set(this.itemData.fieldconfig, 'isallowminus', this.cloneData.fieldconfig.isallowminus)
        this.$set(this.itemData.fieldconfig, 'isallowdecimals', this.cloneData.fieldconfig.isallowdecimals)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.set-time-row::v-deep {
  .ant-form-item-label {
    float:left;
    width: 100px;
    label {
      color: #666;
      margin-right: 16px;
    }
  }
  .ant-form-item-control-wrapper {
    float: left;
    .ant-radio-wrapper {
      margin-right: 20px;
    }
  }
}
</style>
